<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_SectionHead" id="auto_bookmark_toc_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText">Frank Herbert’s magnificent Dune saga sprawls across countless planets and tens of millennia. Brian Herbert and Kevin J. Anderson have written thirteen international bestselling novels set in this epic universe. But the wealth of material leaves many side tales or interesting ideas that can be told, hors d’oeuvres to accompany the exotic main course.</p>
<p class="P_WFP_BodyText">Sometimes, a short story is exactly what’s needed.</p>
<p class="P_WFP_BodyText"><i>Tales of Dune</i> collects eight of Herbert and Anderson’s Dune short stories, ranging from the period of the Butlerian Jihad, to the time of young Paul Atreides, to a story set during the events of the novel <i>Dune</i>, to the very end of Frank Herbert’s future history.</p>
<p class="P_WFP_BodyText">These are the missing pieces in the epic of Dune.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?531835e6